var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe5e8"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 121,
    x2: 389,
    xlinkHref: "#lg1",
    y1: 85.724,
    y2: 85.724
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(-1 0 0 1 510 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 138,
    x2: 372,
    xlinkHref: "#lg1",
    y1: 93.814,
    y2: 93.814
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.171,
    x2: 157.335,
    xlinkHref: "#lg2",
    y1: 147.752,
    y2: 187.916
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.021,
    x2: 398.224,
    xlinkHref: "#lg2",
    y1: 140.122,
    y2: 196.326
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.513,
    x2: 357.513,
    y1: 181.416,
    y2: 168.916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f46700"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 325.513,
    y2: 440.287
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 454,
    x2: 408,
    y1: 376.238,
    y2: 376.238
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e5959",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe99a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd4755"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.564,
    x2: 192.903,
    xlinkHref: "#lg4",
    y1: 276.947,
    y2: 321.205
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.34,
    x2: 315.978,
    xlinkHref: "#lg4",
    y1: 281.628,
    y2: 319.348
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.363,
    x2: 362.638,
    y1: 171.181,
    y2: 171.181
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d78878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca6e59"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.656,
    x2: 328.345,
    xlinkHref: "#lg5",
    y1: 54.75,
    y2: 108.439
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.064,
    x2: 301.03,
    xlinkHref: "#lg5",
    y1: 85.305,
    y2: 85.305
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 187,
    y2: 227.749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa9b1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#ffa78f"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.069,
    x2: 256.069,
    y1: 533.169,
    y2: 471.835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#883f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d3326"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 453.809,
    y2: 478.766
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca6e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883f2e"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.445,
    x2: 298.315,
    xlinkHref: "#lg1",
    y1: 275.251,
    y2: 444.01
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.36,
    x2: 241.298,
    y1: 379.526,
    y2: 335.464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 412.579,
    y2: 448.972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.643,
    x2: 222.928,
    xlinkHref: "#lg3",
    y1: 172.848,
    y2: 172.848
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.072,
    x2: 318.357,
    xlinkHref: "#lg3",
    y1: 172.848,
    y2: 172.848
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.169,
    x2: 475.227,
    y1: 169.634,
    y2: 214.693
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1835,
    stopColor: "#56aff6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5011,
    stopColor: "#3a97e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9121,
    stopColor: "#0c71bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.673,
    x2: 493.809,
    y1: 59.677,
    y2: 120.812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e9af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fc123"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.156,
    x2: 84.993,
    xlinkHref: "#lg4",
    y1: 31.602,
    y2: 97.439
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m389 136.134v33.18h-268v-33.18c0-74 59.99-134 134-134 37 0 70.5 15 94.75 39.25s39.25 57.75 39.25 94.75z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138 139.345v29.969h234v-29.969c0-66.838-52.379-121.031-117-121.031-32.306 0-61.556 13.548-82.729 35.451s-34.271 52.161-34.271 85.58z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m102.477 169.341c0-23.615 16.393-43.402 38.419-48.601 5.888-1.39 11.516 3.163 11.516 9.213v78.777c0 6.05-5.628 10.603-11.516 9.213-22.026-5.2-38.419-24.987-38.419-48.602z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.523 169.341c0-23.615-16.393-43.402-38.419-48.601-5.888-1.39-11.516 3.163-11.516 9.213v78.777c0 6.05 5.628 10.603 11.516 9.213 22.026-5.2 38.419-24.987 38.419-48.602z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.655 122.989c-1.865 1.717-3.068 4.177-3.068 6.964v78.777c0 6.05 5.628 10.603 11.516 9.213 21.869-5.162 38.176-24.706 38.409-48.097z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m454.462 447.882h-398.924v-15.825c0-84.43 68.444-152.874 152.873-152.874h93.176c84.43 0 152.873 68.444 152.873 152.874v15.825z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386 304.593v143.289h68.462v-15.825c0-53.224-27.205-100.087-68.462-127.464z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m179.057 270.808s-22.129 11.064-15.088 20.117c5.179 6.659 31.581 32.363 45.183 45.494 4.51 4.353 11.665 4.279 16.097-.153l29.75-29.75z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.943 270.808s22.129 11.064 15.088 20.117c-5.179 6.659-31.581 32.363-45.183 45.494-4.51 4.353-11.665 4.279-16.097-.153l-29.751-29.749z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 306.418c-59.447 0-107.638-48.191-107.638-107.637v-55.199c0-59.447 48.191-107.637 107.637-107.637 59.447 0 107.637 48.191 107.637 107.637v55.199c.002 59.446-48.189 107.637-107.636 107.637z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m360.683 123.068c1.159 6.008-3.389 11.601-9.508 11.601h-15.925c-22.12 0-41.4-12.19-51.48-30.23-4.74-8.49-7.44-18.27-7.44-28.69 0-15.4 10.22-26.67 22.78-30.38l.49.22c11.8 5.38 22.46 12.83 31.51 21.88 14.88 14.881 25.427 34.101 29.573 55.599z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.03 54.9c0 18.71-6.45 35.93-17.26 49.54-14.6 18.42-37.18 30.23-62.51 30.23h-41.73c-8.581 0-16.72-1.917-23.999-5.345-4.098-1.93-6.256-6.533-5.2-10.938 11.338-47.291 53.902-82.447 104.669-82.447 15.72 0 30.65 3.37 44.11 9.43l.49.22c.93 2.95 1.43 6.08 1.43 9.31z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m260.946 225.853h-11.893c-9.911 0-17.415-8.956-15.679-18.714l6.817-38.324h29.616l6.817 38.324c1.737 9.757-5.767 18.714-15.678 18.714z",
    fill: "url(#SVGID_13_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m461.522 507.866h-410.906c-5.806 0-10.513-4.707-10.513-10.513v-25.481h431.932v25.481c0 5.806-4.707 10.513-10.513 10.513z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.154 478.351h-462.308c-2.972 0-5.381-2.409-5.381-5.381v-19.708c0-2.972 2.409-5.381 5.381-5.381h462.308c2.972 0 5.381 2.409 5.381 5.381v19.708c0 2.972-2.409 5.381-5.381 5.381z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m393.527 250.45h-277.054c-6.069 0-10.988 4.92-10.988 10.988v171.626c0 8.184 6.634 14.818 14.818 14.818h269.394c8.184 0 14.818-6.634 14.818-14.818v-171.625c0-6.069-4.919-10.989-10.988-10.989z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 349.166,
    fill: "url(#SVGID_17_)",
    r: 26.436
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.485 385.8v47.264c0 8.184 6.634 14.818 14.818 14.818h269.394c8.184 0 14.818-6.634 14.818-14.818v-47.264z",
    fill: "url(#SVGID_18_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m207.285 192.502c-8.639 0-15.643-7.003-15.643-15.643v-8.022c0-8.639 7.003-15.643 15.643-15.643 8.639 0 15.643 7.003 15.643 15.643v8.022c0 8.639-7.004 15.643-15.643 15.643z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.715 192.502c-8.639 0-15.643-7.003-15.643-15.643v-8.022c0-8.639 7.003-15.643 15.643-15.643 8.639 0 15.643 7.003 15.643 15.643v8.022c-.001 8.639-7.004 15.643-15.643 15.643z",
    fill: "url(#SVGID_20_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m474.465 166.743c-1.869-1.869-2.915-4.407-2.904-7.052.024-5.654-4.612-10.224-10.266-10.224h-5.039-7.404c-2.714 0-4.915 2.2-4.915 4.915v30.716c-5.185-1.105-11.213-.055-16.522 3.353-9.543 6.125-13.14 17.537-8.036 25.489s16.978 9.433 26.521 3.308c6.421-4.121 10.144-10.636 10.343-16.88h.014v-39.951h1.669c1.767 0 3.199 1.432 3.199 3.199 0 1.444.968 2.71 2.362 3.088l9.509 2.576c1.5.406 2.568-1.438 1.469-2.537z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482.516 42.574-6.383 2.885c-8.905 4.024-18.564 6.106-28.336 6.106h-3.228c-5.044 0-9.133 4.089-9.133 9.133v10.84 21.62c-6.052-1.29-13.09-.064-19.287 3.914-11.139 7.15-15.339 20.472-9.381 29.755s19.819 11.012 30.958 3.862c7.495-4.811 11.842-12.415 12.073-19.704h.016v-39.479c9.081-.267 18.026-2.327 26.316-6.074l19.488-8.807v21.62c-6.052-1.29-13.09-.064-19.287 3.914-11.139 7.15-15.339 20.472-9.381 29.754 5.958 9.283 19.819 11.012 30.958 3.862 7.495-4.811 11.842-12.415 12.073-19.704h.018v-39.447-9.443c0-5.677-5.119-9.962-10.713-8.996-5.747.993-12.505 2.461-16.771 4.389z",
    fill: "url(#SVGID_22_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m83.88 27.377c-2.731-2.731-4.259-6.44-4.243-10.304.034-8.262-6.738-14.939-15-14.939h-7.363-10.818c-3.966 0-7.182 3.215-7.182 7.182v44.881c-7.576-1.615-16.385-.08-24.141 4.899-13.944 8.949-19.201 25.624-11.743 37.243s24.808 13.783 38.751 4.833c9.382-6.022 14.823-15.541 15.112-24.664h.02v-58.374h2.439c2.582 0 4.674 2.092 4.674 4.674 0 2.111 1.415 3.96 3.452 4.511l13.894 3.765c2.193.593 3.754-2.102 2.148-3.707z",
    fill: "url(#SVGID_23_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusic);
export default __webpack_public_path__ + "static/media/icon-music.9c659dbd67f892f8132855be35f669f3.svg";
export { ForwardRef as ReactComponent };